import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  chartList: [],
  isChartListLoading: false,
  showChartList: [],
  searchList: {
    data : [],
    tot_cnt : 0,
    listType : null,
  },
  isMore: false,
  isModal: false,
};

const fetchChartData = createAsyncThunk(
  "dashboard/fetchChartData",
  async (defaultChartSet) => {
    let { f_id, day } = defaultChartSet;
    try {
      const { data } = await axios.get(
        `https://api.floway.co.kr/api/transactions/chart/${f_id}/${day}`
      );
      data.data?.shift();
      const payload = data.data;
      return payload;
    } catch (e) {
      console.error(e);
      return false;
    }
  }
);

const fetchSearchData = createAsyncThunk(
  "dashboard/fetchSearchData",
  async ({ page, name }) => {
    try {
      const { data } = await axios.get(
        `https://api.floway.co.kr/api/flowers/predSearch/${name}/${page}`
      );

      return data;
    } catch (e) {
      console.error(e);
    }
  }
);

const dashBoardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    resetFlowerSearchData(state) {
      state.searchList = {}
      state.searchList.data = [];
      state.searchList.listType = null;
      state.searchList.tot_cnt = 0;

      console.log(state.searchList)
    },
    moreLoadChartData(state) {
      const offset = state.showChartList?.length;
      const limit = offset + 5;
      state.showChartList = [
        ...(state.showChartList || []),
        ...(state.chartList?.slice(offset, limit) || []),
      ];

      if (state.showChartList?.length === state.chartList?.length) {
        state.isMore = false;
        return;
      }
    },
    changeSearchListType(state) {
      state.searchList.listType = null;
    },
    toggleModal(state) {
      state.isModal = !state.isModal;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchChartData.pending, (state) => {
        state.isChartListLoading = false;
      })
      .addCase(fetchChartData.fulfilled, (state, action) => {
        state.chartList = action.payload;

        if (action.payload?.length > 5) {
          state.showChartList = action.payload.slice(0, 5);
          state.isMore = true;
          state.isChartListLoading = true;
          return;
        }
        state.showChartList = action.payload;
        state.isMore = false;
        state.isChartListLoading = true;
      })
      .addCase(fetchChartData.rejected, (state) => {
        state.isChartListLoading = true;
      });

    builder
      .addCase(fetchSearchData.pending, () => { })
      .addCase(fetchSearchData.fulfilled, (state, action) => {
        state.searchList = action.payload;
      })
      .addCase(fetchSearchData.rejected, () => { });
  },
});

const DashBoardCreators = {
  fetchChartData,
  fetchSearchData,
};

export { DashBoardCreators };
const { reducer, actions } = dashBoardSlice;
export const { moreLoadChartData, toggleModal, changeSearchListType, resetFlowerSearchData } = actions;
export default reducer;
